export {
  type CatchupResult,
  type FileWatcherConfig,
  type FileWatcherHandle,
  getEventsSince,
  startFileWatcher,
} from './file-watcher.js';

export {
  createIncrementalIndexer,
  type IncrementalIndexerConfig,
} from './incremental-indexer.js';
